import { render, staticRenderFns } from "./FeesGraph.vue?vue&type=template&id=470ceaaf&scoped=true&"
import script from "./FeesGraph.vue?vue&type=script&lang=js&"
export * from "./FeesGraph.vue?vue&type=script&lang=js&"
import style0 from "./FeesGraph.vue?vue&type=style&index=0&id=470ceaaf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ceaaf",
  null
  
)

export default component.exports